module.exports = __webpack_public_path__ + "media/unipod/installation_horizontal_1-40d8964f.jpg";